import { jsxs, Fragment } from 'react/jsx-runtime';
import { keyframes, styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { cssPropertySizeValue } from '../utils/cssProperties.js';

const shimmer = keyframes([
  `100%{transform:translateX(100%);}`
]);
const Skeleton = styled.span.attrs((props) => {
  return {
    children: /* @__PURE__ */ jsxs(Fragment, {
      children: [
        props.children,
        "‌‌"
      ]
    })
  };
}).withConfig({
  displayName: "Skeleton",
  componentId: "sc-28f43117-0"
})([
  `--shimmer-colour-rgb:`,
  `;background:`,
  `;color:transparent;width:100%;line-height:1;display:inline-flex;position:relative;overflow:hidden;border-radius:`,
  `;width:`,
  `;height:`,
  `;scale:`,
  `;&::after{position:absolute;top:0;right:0;bottom:0;left:0;transform:translateX(-100%);background-image:linear-gradient( 90deg,rgba(var(--shimmer-colour-rgb),0) 0,rgba(var(--shimmer-colour-rgb),0.2) 20%,rgba(var(--shimmer-colour-rgb),0.5) 60%,rgba(var(--shimmer-colour-rgb),0) );animation:`,
  ` 1s infinite;content:'';}`
], cssVar["color-bg-quarternary-rgb"], cssVar["color-bg-tertiary"], (props) => props.circle ? "50%" : `${props.borderRadius || 0}px`, (props) => cssPropertySizeValue(props.width), (props) => cssPropertySizeValue(props.height), (props) => props.scale, shimmer);

export { Skeleton as default };
//# sourceMappingURL=Skeleton.js.map
